package com.anjuros.website.redesign.sections.about

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.AboutServiceStyle
import com.anjuros.website.redesign.styles.AboutServicesGridStyle
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private class Service(val path: String, val title: RdText, val text: RdText, val link: RdText)

private val Services = listOf(
    Service(RdRoute.DESIGNS, RdText.SERVICE1_TITLE, RdText.SERVICE1_TEXT, RdText.SERVICE1_LINK),
    Service(RdRoute.PRICING, RdText.SERVICE2_TITLE, RdText.SERVICE2_TEXT, RdText.SERVICE2_LINK),
    Service(RdRoute.PORTAL, RdText.SERVICE3_TITLE, RdText.SERVICE3_TEXT, RdText.SERVICE3_LINK),
    Service(RdRoute.SEO, RdText.SERVICE4_TITLE, RdText.SERVICE4_TEXT, RdText.SERVICE4_LINK),
)

/** "What I do": links to the main services. */
@Composable
fun AboutServicesSection() {
    RdSection(id = "services", labelledBy = "services-h") {
        RdSectionHead(RdText.ABOUT_SERVICES_EYEBROW, "services-h", RdText.ABOUT_SERVICES_TITLE)
        Div(AboutServicesGridStyle.toModifier().toAttrs()) {
            Services.forEach { service ->
                RdLink(service.path, AboutServiceStyle.toModifier()) {
                    H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(service.title)) }
                    P { Text(LocalText(service.text)) }
                    Span { Text(LocalText(service.link) + " →") }
                }
            }
        }
    }
}
